import {
  deleteDataFromServer,
  deleteDataFromServerWithFullResponse,
  getDataFromServer,
  postDataToServer,
  putDataToServer
} from '../../../util';

export class TrmTypologies {
  constructor(baseURL, httpHeaders) {
    this.baseURL = baseURL;
    this.httpHeaders = httpHeaders;
  }

  /**
   * getTypologiesAPI
   * @param payload
   * @returns {Promise<*|*[]>}
   */
  getTypologiesAPI = async (payload) => {
    const url = `${this.baseURL}/typologies`;
    const { page, pageSize, sourceId, searchTerms } = payload;
    const params =
      page && pageSize
        ? {
            limit: pageSize,
            offset: (page - 1) * pageSize,
            sourceId: sourceId,
            searchTerms: searchTerms
          }
        : {};
    const data = await getDataFromServer(url, this.httpHeaders, params);
    if (data) {
      return data;
    } else {
      return [];
    }
  };

  /**
   * removeTypologyFromScenario
   * @param payload
   * @returns {Promise<*|*[]>}
   */
  removeTypologyFromScenario = async (payload) => {
    const { scenarioID, typologyIds } = payload || {};
    const url = `${this.baseURL}/scenarios/${scenarioID}/typologies`;
    const params = {
      typologyIds
    };
    return await deleteDataFromServerWithFullResponse(url, params).then(
      async (res) => {
        if (res.status !== 200 && res.status !== 202 && res.status !== 204) {
          throw new Error(res?.data?.message || 'Failed to delete');
        } else {
          return await this.getTypologiesOfScenariosAPI({ scenarioID });
        }
      }
    );
  };

  /**
   * getTypologiesOfScenariosAPI
   * @param payload
   * @returns {Promise<*|*[]>}
   */
  getTypologiesOfScenariosAPI = async (payload) => {
    const { scenarioID } = payload || {};
    const url = `${this.baseURL}/scenarios/${scenarioID}/typologies`;
    const params = {};
    const data = await getDataFromServer(url, this.httpHeaders, params);
    if (data) {
      return data;
    } else {
      return [];
    }
  };

  /**
   * updateTypologiesOfScenariosAPI
   * @param payload
   * @returns {Promise<*|*[]>}
   */
  updateTypologiesOfScenariosAPI = async (payload) => {
    const { scenarioID, data } = payload || {};
    const url = `${this.baseURL}/scenarios/${scenarioID}/typologies`;
    const params = {};
    return await putDataToServer(url, this.httpHeaders, params, data);
  };
}
